var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "terms"
  }, [_c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.mainTitle)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.descriptionIntro)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title1)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description1)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title2)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description2)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title3)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description3)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title4)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description4)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title5)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description5)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title6)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description6)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title7)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description7)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title8)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title81)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description81)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title82)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description82)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title83)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description83)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title84)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description84)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title85)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description85)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title9)
    }
  }), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title91)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description91)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title92)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description92)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title10)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description10)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title11)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description11)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title12)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description12)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title13)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description13)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title14)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description14)
    }
  }), _c('br'), _c('div', {
    staticClass: "heading-3-bold popup-title",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.title15)
    }
  }), _c('div', {
    staticClass: "paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.field_one.value.description15)
    }
  }), _c('br')]);

}
var staticRenderFns = []

export { render, staticRenderFns }